/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
@file:Suppress("InvalidPackageDeclaration")

package studio.oddpods.cauce.core.base.analytics.di

import org.koin.core.module.Module
import org.koin.dsl.module
import studio.oddpods.cauce.core.base.analytics.StubAnalyticsHelper

actual val analyticsModule: Module
    get() = module {

        // Enable this when Firebase Project is set up
        // single<FirebaseAnalytics> { Firebase.analytics }
        // bindPhiSafeAnalytics { FirebaseAnalyticsHelper(get()) }

        bindPhiSafeAnalytics { StubAnalyticsHelper() }
    }
